<template>
  <v-card>
    <v-tabs :value="stdCommDiscFactTab">
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab @click="fetchStandardCommDiscFactors()">Factors</v-tab>
      <v-tab v-show="displayFactReviewTab" @click="reviewStandardCommDiscFactors()">Factor Info and Rates</v-tab>
      <v-tab v-show="displayRateTab">Rate Info</v-tab>
      <v-tab-item>
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-tab-item>
      <v-tab-item v-if="displayFactReviewTab">
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-tab-item>
      <v-tab-item v-if="displayRateTab">
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import { PRODUCT_STDCOMMDISCFACT_TABMENU } from '@/store/types'
import { appID } from '@/const/underwriting'

export default {
  data() {
    return {
    }
  },
  computed: {
    productAppID() {
      return this.$store.state.productManagement.product.appID
    },
    stdCommDiscFactTab() {
      return this.$store.state.productManagement.product.stdCommDiscFactorTabMenu
    },
    displayFactReviewTab() {
      return this.$store.state.productManagement.product.stdCommDiscFactorDisplayFactReviewTab
    },
    displayRateTab() {
      return this.$store.state.productManagement.product.stdCommDiscFactorDisplayRateTab
    },
    stdCommDiscFactorEffDate() {
      return this.$store.state.productManagement.product.stdCommDiscFactorEffDate
    }
  },
  methods: {
    fetchStandardCommDiscFactors() {
      const commitData = {
        stdCommDiscFactTab: 0,
        displayFactReviewTab: false,
        displayRateTab: false
      }
      this.$store.commit(PRODUCT_STDCOMMDISCFACT_TABMENU, commitData)
      if (this.productAppID === appID.MOTOR) {
        this.$router.push({ name: 'motorStdCommDiscFactors', params: { product: this.product } })
      } else if (this.productAppID === appID.TRAVEL) {
        this.$router.push({ name: 'travelStdCommDiscFactors', params: { product: this.product } })
      } else if (this.productAppID === appID.FIRE) {
        this.$router.push({ name: 'fireStdCommDiscFactors', params: { product: this.product } })
      } else if (this.productAppID === appID.CARGO) {
        this.$router.push({ name: 'cargoStdCommDiscFactors', params: { product: this.product } })
      } else if (this.productAppID === appID.MAID) {
        this.$router.push({ name: 'maidStdCommDiscFactors', params: { product: this.product } })
      } else if (this.productAppID === appID.PACKAGE) {
        this.$router.push({ name: 'packageStdCommDiscFactors', params: { product: this.product } })
      }
    },
    reviewStandardCommDiscFactors() {
      const commitData = {
        stdCommDiscFactTab: 1,
        displayFactReviewTab: true,
        displayRateTab: false
      }
      this.$store.commit(PRODUCT_STDCOMMDISCFACT_TABMENU, commitData)
      if (this.productAppID === appID.MOTOR) {
        this.$router.push({ name: 'motorStdCommDiscFactorReview', params: { effectiveDate: this.stdCommDiscFactorEffDate } })
      } else if (this.productAppID === appID.TRAVEL) {
        this.$router.push({ name: 'travelStdCommDiscFactorReview', params: { effectiveDate: this.stdCommDiscFactorEffDate } })
      } else if (this.productAppID === appID.FIRE) {
        this.$router.push({ name: 'fireStdCommDiscFactorReview', params: { effectiveDate: this.stdCommDiscFactorEffDate } })
      } else if (this.productAppID === appID.CARGO) {
        this.$router.push({ name: 'cargoStdCommDiscFactorReview', params: { effectiveDate: this.stdCommDiscFactorEffDate } })
      } else if (this.productAppID === appID.MAID) {
        this.$router.push({ name: 'maidStdCommDiscFactorReview', params: { effectiveDate: this.stdCommDiscFactorEffDate } })
      } else if (this.productAppID === appID.PACKAGE) {
        this.$router.push({ name: 'packageStdCommDiscFactorReview', params: { effectiveDate: this.stdCommDiscFactorEffDate } })
      }
    }
  },
  props: {
    product: {
      type: String,
      default: ''
    }
  },
  created() {
    this.fetchStandardCommDiscFactors()
  }
}
</script>

<style lang="scss">
</style>
